import React from "react";

import ImagePartitionLayout from '../../../layout/imagepartitionlayout/imagepartitionlayout'
import AuthenticationContainer from "../../../components/AuthenticationContainer/authenticationcontainer";
import MFAScanForm from "../components/mfascanform/mfascanform";
import {MFA_SUBTITLE, WEBSITE_TITLE} from "../../../constants/appconstants";


class MFAScan extends React.Component {
  render() {
    return (
      <ImagePartitionLayout ContentComponent={ <AuthenticationContainer  Component={<MFAScanForm /> } titleLabel={"Setup Authenticator App"}/>}
                            title={WEBSITE_TITLE}
                            subtitle={
                              MFA_SUBTITLE}
      />
    );
  }
}

export default MFAScan;



